import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

/**
 * Modal to create or edit a color name
 */
function ColorModal({
  title = 'Color',
  isOpen = false,
  onToggle = () => {},
  defaultValue = '',
  onSubmit = () => {},
}) {
  const [name, setName] = useState(defaultValue || '');

  // Update name when defaultValue changes (for edit mode)
  useEffect(() => {
    setName(defaultValue || '');
  }, [defaultValue]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    onSubmit(name.trim());
    onToggle(); // Close modal after submit
  };

  const handleCancel = () => {
    setName(defaultValue || ''); // Reset to original value
    onToggle(); // Close modal
  };

  return (
    <Modal isOpen={isOpen} fade={false} toggle={onToggle}>
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label htmlFor="colorName">Nombre del color</Label>
          <Input
            id="colorName"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Ej: Rojo"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit}>
          Guardar
        </Button>
        <Button color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ColorModal;
